import styled from 'styled-components';
import { Popup } from '@fluentui/react';
import {
  PrimaryButton,
  SecondaryButton,
} from 'src/styles/globalStyles/buttonStyles.styled';
import { Textarea } from '@fluentui/react-components';
import { FieldError } from 'react-hook-form/dist/types';
import { isMobile } from 'react-device-detect';
import { Overlay } from '@fluentui/react';

export const TicketsAddBackdrop = styled(Popup)`
  background: ${(props) => props.theme.popupOpacity};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
`;

export const TicketsAddPopupOverlay = styled(isMobile ? styled.div`` : Overlay)`
  background: ${(props) => props.theme.skillsAccordionBackground};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
  width: 420px;
  height: fit-content;
  margin: auto;
  overflow-x: hidden;
  border-radius: 2px;
  max-height: 100svh;

  @media (max-width: 710px) {
    height: 100svh;
    width: 100%;
    overflow-y: scroll;
    position: absolute;

    p {
      font-size: 17px;
      font-weight: 400;
      color: #424242;
    }
  }
`;

export const TicketsTopContainer = styled.div<{ themeString: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 5%;

  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${(props) =>
    props.themeString === 'dark' ? '#0F0F0F' : '#D1D1D1'};

  h1 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 5%;
    margin-left: 2rem;
  }
  svg,
  p {
    margin-bottom: 5%;
    margin-right: 2rem;
    cursor: pointer;
  }
  span {
    margin-bottom: 5%;
    margin-right: 2rem;
    cursor: pointer;
    color: #5b5fc7;
    font-size: 16px;
    font-weight: 500;
  }

  @media (max-width: 710px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 0;

    h1 {
      margin: 0;
      padding: 0 16px 8px;
    }
  }
`;

export const TicketsMiddleContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 32px;
  gap: 12px;
  flex-grow: 1;
  @media (max-width: 710px) {
    padding: 16px 20px 30px;
  }
`;

export const FinishingActionsContainer = styled.div<{ themeString: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 32px;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: ${(props) =>
    props.themeString === 'dark' ? '#0F0F0F' : '#D1D1D1'};
  p {
    margin-right: auto;
    color: #5b5fc7;
    cursor: pointer;
  }

  @media (max-width: 710px) {
    width: 100%;
    min-height: 64px;
    padding: 0px 20px;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    background: ${(props) => props.theme.skillsAccordionBackground} !important;
  }
`;

export const TicketsDiscardButton = styled(SecondaryButton)`
  min-width: 70px;
`;

export const TicketsSaveButton = styled(PrimaryButton)`
  min-width: 70px;
  margin-left: 5px;
`;

export const StyledTextarea = styled(Textarea).attrs({
  appearance: 'filled-darker',
})<{ error: FieldError }>`
  margin-top: -5px;
  transition: all 0.3s ease-in;
  font-size: ${() => (isMobile ? '16px' : '14px')};
  font-weight: 400;
  min-height: 175px;
  @media (max-width: 768px) {
    font-size: 16px;
    textarea {
      font-size: 16px;
    }
  }

  textarea {
    max-height: 320px;
  }
`;

export const TicketsAddForm = styled.form`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
